import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { previewAssistMigration } from 'api/assist/migration/previewAssistMigration';
import { ApiError } from 'types/api';
import { AssistMigrationPreview } from 'types/assist/assistMigration';

interface PreviewAssistMigrationPayload {
  businessId: number;
}

export const usePreviewAssistMigration = () => {
  return useMutation<AssistMigrationPreview | null, ApiError, PreviewAssistMigrationPayload>({
    mutationFn: async ({ businessId }) => {
      const { data } = await previewAssistMigration(businessId);

      return data.data;
    },
    onError: (error) => {
      Sentry.captureException(error);
      toast.error(
        error?.response?.data?.error ?? 'Failed to build the migration preview',
        { duration: 4000 },
      );
    },
  });
};
